export const isDarkTheme = () => {
    var _a, _b;
    if ((_b = (_a = document === null || document === void 0 ? void 0 : document.body) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.contains('theme-fandomdesktop-dark')) {
        return true;
    }
    return false;
};
